import React, { useState, useEffect } from "react";
import { toast } from "sonner";
import { Heart } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { BusinessCard, ListingCard, ServiceCard, RequestCard } from "@/components/cards";
import { EmptyState, PageLoading, SectionHeader } from "@/components/common";

export default function Saved() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/favourites").then(({ data }) => setData(data)); }, []);

  const unsaveMarketplace = async (lid) => {
    setData((d) => ({ ...d, marketplace: d.marketplace.filter((l) => l.id !== lid) }));
    try { await api.delete("/favourites", { params: { item_type: "marketplace", item_id: lid } }); toast.success("Removed from Saved"); }
    catch (e) { toast.error(apiError(e)); api.get("/favourites").then(({ data }) => setData(data)); }
  };

  if (!data) return <PageLoading />;
  const empty = !data.business.length && !data.marketplace.length && !data.service.length && !data.request.length;
  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <h1 className="font-display text-2xl font-bold tracking-tight">Saved</h1>
      {empty ? <EmptyState icon={Heart} title="Nothing saved yet" subtitle="Tap the heart on any business, item or service to save it here." /> : (
        <>
          {data.marketplace.length > 0 && <section><SectionHeader title="Items" /><div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">{data.marketplace.map((l) => <ListingCard key={l.id} l={l} onUnsave={unsaveMarketplace} />)}</div></section>}
          {data.business.length > 0 && <section><SectionHeader title="Businesses" /><div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">{data.business.map((b) => <BusinessCard key={b.id} b={b} />)}</div></section>}
          {data.service.length > 0 && <section><SectionHeader title="Services" /><div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">{data.service.map((s) => <ServiceCard key={s.id} s={s} />)}</div></section>}
          {data.request.length > 0 && <section><SectionHeader title="Requests" /><div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">{data.request.map((r) => <RequestCard key={r.id} r={r} />)}</div></section>}
        </>
      )}
    </div>
  );
}
